import { ExternalTrainings } from './ExternalTrainings';

export default ExternalTrainings;
